import React from 'react';

import './LoaderOrangeRings.less';

export const LoaderOrangeRings = () => (
    <div className="loader-orange-rings" data-atid="loader-orange-rings">
        <div className={'bounce1'} />
        <div className={'bounce2'} />
        <div className={'bounce3'} />
    </div>
);
